import React, { useEffect, useState } from "react";
import { FcGoogle } from "react-icons/fc";
import YoutubeApi from "./server";
import { toast } from "react-toastify";

const LoginYT = ({ setIsLoggedIn, loginError }) => {
  const [uploadStatus, setUploadStatus] = useState("");
  const getAuthUrl = async () => {
    try {
      const { data } = await YoutubeApi.youtubeAuth();
      window.location.href = data?.data?.authUrl;
    } catch (error) {
      console.error("Error fetching auth URL:", error);
      setUploadStatus("Failed to initiate authentication.");
    }
  };

  const getToken = async () => {
    try {
      const res = await YoutubeApi.getOauthToken();
      if (res.status === 201) {
        toast.error("Login credentials failed");
        setUploadStatus("Failed to initiate authentication.");
        setIsLoggedIn(false);
      } else if (res.status === 200) {
        setIsLoggedIn(true);
        // toast.success("Login successfully");
      }
    } catch (error) {
      console.error("Error fetching auth URL:", error);
      setUploadStatus("Failed to initiate authentication.");
    }
  };

  useEffect(() => {
    if (!loginError) {
      getToken();
    }
  }, [loginError]);

  return (
    <div className="bg-white p-6 w-full h-full flex flex-col items-center justify-start">
      <h2 className="text-2xl font-bold mb-4">Login to Your Account</h2>
      <button
        onClick={getAuthUrl}
        className="bg-white flex text-black items-center gap-3 border border-gray-400 rounded-sm px-4 py-2"
      >
        <FcGoogle className="text-xl" />
        Login with Google
      </button>
      {uploadStatus && <p className="text-red-500 mt-4">{uploadStatus}</p>}
    </div>
  );
};

export default LoginYT;
